module.exports = "/work-site/img/unusual_weather.bff95d8b.png";